import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=1260b201&scoped=true"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=1260b201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260b201",
  null
  
)

export default component.exports